import { Types } from "../actions/companyActions";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { NotificationManager } from "react-notifications";

const defaultState = {
	company: {},
};

const companyReducers = (state = defaultState, action) => {
	switch (action.type) {
		case Types.COMPANY_TAB: {
			let newState = _.cloneDeep(state);
			newState.company.tab = action.tab;
			return newState;
		}
		case Types.COMPANY_NEW_OPEN_MODAL: {
			let newState = _.cloneDeep(state);
			if (action.isNewCompanyModalOpen)
				newState.company.newCompany = {
					overtimes: [],
					allowances: [],
					paySchedules: [
						{
							id: uuidv4(),
							public: "no",
							name: "Monthly",
							payFrequency: 12,
							deadline: {
								value: "2",
								type: "days",
							},
							payDay: {
								value: "last day",
								type: "of the period",
							},
						},
					],
				};
			newState.company.isNewCompanyModalOpen = action.isNewCompanyModalOpen;
			return newState;
		}
		case Types.COMPANY_OPEN_MODAL: {
			let newState = _.cloneDeep(state);
			newState.company.isCompanyModalOpen = action.isCompanyModalOpen;
			return newState;
		}
		case Types.COMPANY_LOADING: {
			let newState = _.cloneDeep(state);
			newState.company.loading = action.loading;
			return newState;
		}
		case Types.COMPANY_ADVANCED_SETTINGS_MODAL: {
			let newState = _.cloneDeep(state);
			newState.company.advancedSettingsModal = action.toggle
				? { id: action.toggle, type: action.modalType }
				: undefined;
			return newState;
		}
		case Types.COMPANY_BANK_TRANSFER_MODAL: {
			let newState = _.cloneDeep(state);

			const isOpen = action.isBankTransferModalOpen;

			newState.company.bankTransferModal = { ...newState.company.bankTransferModal, isOpen: isOpen };

			if (newState.integration?.payment?.stage) {
				delete newState.integration.payment.stage;
				delete newState.integration.payment.syncError;
				delete newState.integration.payment.syncingStatus;
				delete newState.integration.payment.unsyncedEmployees;
			}

			return newState;
		}
		case Types.COMPANY_SHOW_BILLING_MODAL: {
			let newState = _.cloneDeep(state);

			const billingModal = action.billingModal;

			newState.company.billingModal = billingModal;

			return newState;
		}

		case Types.COMPANY_BANK_TRANSFER_PERIOD: {
			let newState = _.cloneDeep(state);

			const period = action.period;

			newState.company.bankTransferModal = { ...newState.company.bankTransferModal, period: period };
			return newState;
		}
		case Types.COMPANY_FILE_UPLOADING: {
			let newState = _.cloneDeep(state);

			newState.company.filesUploading = newState.company.filesUploading
				? [...newState.company.filesUploading, action.file]
				: [action.file];

			return newState;
		}
		case Types.COMPANY_FILE_UPLOADED: {
			let newState = _.cloneDeep(state);

			newState.company.filesUploading = newState.company.filesUploading.filter((name) => name != action.file);

			const fileDetails = { name: action.file, key: action.key };
			newState.company.filesUploaded = newState.company.filesUploaded
				? [...newState.company.filesUploaded, fileDetails]
				: [fileDetails];

			NotificationManager.success(`${action.file} has been uploaded`, "Success");
			return newState;
		}
		case Types.COMPANY_LOADED_SETTINGS: {
			let newState = _.cloneDeep(state);

			newState.company.loading = false;

			const jurisdiction = state.jurisdictions?.find((item) => item.countryCode == action.payload.jurisdiction);

			newState.company[action.newModal ? "newCompany" : "settings"] = {
				...(action.payload.org ? {...jurisdiction, taxForms: undefined, taxFormRows: undefined} : {}),
				...(action.newModal ? newState.company[action.newModal ? "newCompany" : "settings"] : {}),
				...action.payload,
			};

			newState.jurisdiction = {
				...newState.jurisdiction,
				...jurisdiction
			}

			if (action.payload.jurisdiction == "UK") {
				newState.company[action.newModal ? "newCompany" : "settings"].sickPaySchemes = [
					{ id: undefined, name: "Standard Statutory Sick Pay", benefit: 99.35 },
					...(action.payload.sickPaySchemes || []),
				];
				window.zE("webWidget", "chat:addTags", ["zopim_chat_UK"]);
				window.zE("webWidget", "chat:removeTags", ["zopim_chat_MT"]);
			} else {
				window.zE("webWidget", "chat:addTags", ["zopim_chat_MT"]);
				window.zE("webWidget", "chat:removeTags", ["zopim_chat_UK"]);
			}

			if (newState?.my?.profile?.givenName && newState?.my?.profile?.familyName) {
				window?.zE?.identify?.({
					name: `${newState?.my?.profile?.givenName} ${newState?.my?.profile?.familyName}`,
					email: newState?.my?.profile?.email,
					organization: action.payload.name,
					[360011072412]: action.payload.name,
				});

				const zELanguageCodes = {
					MT: "en-mt",
					UK: "en-gb",
				};

				try {
					window.zE("webWidget", "setLocale", zELanguageCodes[action.payload.jurisdiction]);
				} catch (error) {
					console.error(error);
				}

				window.startChatMessage = `I'm currently working on ${action.payload.name} (this is an automated message)`;

				window.zE("webWidget:on", "chat:end", function () {
					delete newState.my.profile.zendesk.chatStatus;
				});
			}

			if (action.payload.plan && state.payment.bundles) {
				const planDetails = state.payment.bundles.find((bundle) => bundle.id == action.payload.plan);
				newState.permissions = {...newState.permissions}
				newState.permissions.plan = planDetails?.permissions;

				if (newState.permissions?.plan?.advisorOnly && !newState.my.profile.isAdmin){
				  // check if this user is an advisor else decline all permissions
				  if (!newState.my.profile.isAdvisor || newState.my.profile.advisorId != newState.company.settings.advisor){
					  newState.permissions.plan = {};
				  }
				}
			}

			return newState;
		}
		case Types.COMPANY_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);
			if (action.fieldType) {
				newState.company.settings[action.fieldType][
					newState.company.settings[action.fieldType].findIndex((field) => field.id == action.id)
				][action.field] = action.newValue;
			} else if (action.newCompany) {
				newState.company.newCompany[action.field] = action.newValue;
			} else {
				if (action.field.includes("."))	{
					const fields = action.field.split(".");
					if (!newState.company.settings[fields[0]]){
						newState.company.settings[fields[0]] = {};
					}
					newState.company.settings[fields[0]][fields[1]] = action.newValue;
				} else {
					newState.company.settings[action.field] = action.newValue;
				}
			}
			return newState;
		}
		case Types.COMPANY_MULTI_OPTION_FIELD: {
			let newState = _.cloneDeep(state);
			const id = uuidv4();

			newState.company.settings[action.field] = [...newState.company.settings[action.field], { id }];

			return newState;
		}
		case Types.COMPANY_CREATING: {
			let newState = _.cloneDeep(state);
			newState.company.newCompany.details = action.payload;
			return newState;
		}
		case Types.COMPANY_GET_BY_ADVISOR: {
			let newState = _.cloneDeep(state);
			newState.advisor.companies = action.payload;
			return newState;
		}
		case Types.COMPANY_ADMIN_LIST: {
			let newState = _.cloneDeep(state);
			if (!newState.admin) {
				newState.admin = {};
			}
			newState.admin.organisations = _.orderBy(action.payload, ["name"], ["asc"]);
			return newState;
		}
		case Types.COMPANY_CREATED: {
			let newState = _.cloneDeep(state);
			newState.company.newCompany.org = action.id;
			return newState;
		}
		case Types.COMPANY_DETAILS_UPDATING: {
			let newState = _.cloneDeep(state);
			newState.company.saving = action.status;
			return newState;
		}
		case Types.COMPANY_ARCHIVE_MODAL: {
			let newState = _.cloneDeep(state);

			const archiveModal = action.show;
			newState.company.archiveModal = archiveModal;
			return newState;
		}
		case Types.COMPANY_HMRC_PASSWORD_UPDATING: {
			let newState = _.cloneDeep(state);
			newState.company.gatewayPasswordModal.saving = action.status;
			return newState;
		}
		case Types.COMPANY_HMRCCREDENTIALS_MODAL_STATUS: {
			let newState = _.cloneDeep(state);
			if (!newState.company.gatewayPasswordModal){
				newState.company.gatewayPasswordModal = {};
			}
			newState.company.gatewayPasswordModal.status = action.status;
			return newState;
		}
		case Types.COMPANY_LOADED_ADVISOR: {
			let newState = _.cloneDeep(state);
			newState.company.advisor = action.payload;
			return newState;
		}
		case Types.COMPANY_UPDATE_PERIOD_MODAL: {
			let newState = _.cloneDeep(state);
			newState.company.updatePeriodModal = { id: action.id, proposedType: action.proposedType };
			return newState;
		}
		case Types.COMPANY_UPDATE_SETUP_TOGGLE: {
			let newState = _.cloneDeep(state);

			const prevChecked = newState.company.settings.setup?.checked || {};

			const newSetup = {
				checked: {
					...prevChecked,
					[action.key]: prevChecked[action.key] ? false : true,
				},
			};

			newState.company.settings.setup = {
				...newState.company.settings?.setup,
				...newSetup,
			};

			return newState;
		}
		case Types.COMPANY_UPDATE_SETUP_TARGETS: {
			let newState = _.cloneDeep(state);

			const prevTargets = newState.company.settings.setup?.targets || {};

			const newSetup = {
				targets: {
					...prevTargets,
					[action.key]: action.value,
				},
			};

			newState.company.settings.setup = {
				...newState.company.settings?.setup,
				...newSetup,
			};

			return newState;
		}
		case Types.COMPANY_UPDATE_SETUP_PROGRESS: {
			let newState = _.cloneDeep(state);

			newState.company.settings.setup = {
				...newState.company.settings?.setup,
				steps: action.progress
			};

			return newState;
		}
		case Types.COMPANY_LOADED_JURISDICTIONS: {
			let newState = _.cloneDeep(state);
			newState.jurisdictions = action.payload;
			return newState;
		}
		case Types.COMPANY_GET_BILLING_EMAILS: {
			let newState = _.cloneDeep(state);

			newState.company.billingEmails = action.payload;

			return newState;
		}
		case Types.COMPANY_OPEN_BILLING_EMAIL_MODAL: {
			let newState = _.cloneDeep(state);

			newState.company.billingEmailModal = action.email;
			newState.company.billingEmailModalStatus = action.status;

			return newState;
		}
		default:
			return state;
	}
};

export default companyReducers;